module.exports = "<sx-template-listado \r\n  [titulo]=\"'Report (PDF)'\"\r\n  [listado]=\"reports\"> \r\n</sx-template-listado>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/productReport/list.productreport.component.html
// module id = ../../../../../src/app/private/product/productReport/list.productreport.component.html
// module chunks = main